import { IAppState } from '../../common/state';

export function getNewbuildingHeaderData(state: IAppState) {
  return {
    breadcrumbs: state.breadcrumbs,
  };
}
